export default (): string => Date.now().toString();
